// removed by extract-text-webpack-plugin
module.exports = {"bg-image":"_39kJxFQj_aD7DP6QZe88Yw","no-skills":"ePJoLwJL9FKW67ZxibFS7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Skills/components/SkillsPlaceholder.mod.css
// module id = 1721
// module chunks = 0